import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'
import { Table, Button, Modal, message } from 'antd'
import { getTemplateList, deletePermissionTemplate } from '../../api/permissionTemplate'
import moment from 'moment'

class ClubModuleManage extends Component {
    state = {
        permissionTemplate: [],
        dataSource: [],
        title: 'Warning',
        visible: false,
        confirmLoading: false,
        text: '确定要删除吗?',
        handlingId: '',
        isLoading: true
    }

    componentDidMount() {
        getTemplateList().then((data) => {
            this.setState({
                dataSource: data.data,
                isLoading: false
            })
        }).catch(() => {
            this.setState({isLoading: false})
        })
    }

    render() {
        const columns = [
            {
                title: '模板ID',
                dataIndex: 'id',
                key: 'id',
            },
            {
                title: '模板名',
                dataIndex: 'name',
                key: 'name',
            },
            {
                title: '创建时间',
                dataIndex: 'createTime',
                key: 'createTime',
                render: (text, record, index) => {
                    return (
                        <span>{ moment(text).format('YYYY-MM-DD') }</span>
                    )
                }
            },
            {
                title: '创建人',
                dataIndex: 'memberName',
                key: 'memberName',
            },
            {
                title: '操作',
                dataIndex: 'handling',
                key: 'handling',
                render: (text, record, index) => {
                    return (
                        <Button type="primary" danger onClick={() => {
                            this.setState({
                                visible: true,
                                handlingId: record.id
                            })
                        }}>删除</Button>  
                    )
                },
            },
        ]
        
        // 点击确定
        const handleOk = () => {
            this.setState({
                confirmLoading: true,
            })
            deletePermissionTemplate(this.state.handlingId).then((data) => {
                if (data.status == 1) {
                    this.setState({
                        visible: false,
                        confirmLoading: false,
                    })
                    message.success('操作成功')
                    this.setState({isLoading: true})
                    getTemplateList().then((data) => {
                        this.setState({
                            dataSource: data.data,
                            isLoading: false
                        })
                    }).catch(() => {
                        this.setState({isLoading: false})
                    })
                } else {
                    this.setState({ confirmLoading: false })
                    message.error('操作失败')
                }
            })
        }
        const handleCancel = () => {
            this.setState({visible: false})
        }
        
        return (
            <div>
                <Table rowKey="id" loading={this.state.isLoading} dataSource={this.state.dataSource} columns={columns} />
                <Modal
                    title={this.state.title}
                    visible={this.state.visible}
                    onOk={handleOk}
                    confirmLoading={this.state.confirmLoading}
                    onCancel={handleCancel}
                >
                    <p>{this.state.text}</p>
                </Modal>
            </div>
        )
    }
}

export default withRouter(ClubModuleManage)



// WEBPACK FOOTER //
// ./src/containers/ClubModuleManage/index.js